const MuiSelect = {
    select: {
        padding: '16px',
    },
};

export default MuiSelect;
